import { UserForm } from '@/components/admin/user-form'

export type UserCanvasFormProps = {
  userId: string
  onClose: () => void
  onSuccess: () => void
  platformMode?: boolean
}

export function UserCanvasForm({ userId, onClose, onSuccess, platformMode = false }: UserCanvasFormProps) {
  return (
    <UserForm
      userId={userId}
      variant="canvas"
      platformMode={platformMode}
      onCancel={onClose}
      onSuccess={onSuccess}
    />
  )
}
